import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import SocialLinks from './SocialLinks';

import { UseNav } from '../../context/NavContext';
import { UserMode } from '../../context/ModeContext';

const navItems = [
  { name: 'Home', to: '/' },
  { name: 'Galleries', to: '/galleries' },
  { name: 'About', to: '/about' },
];

const NavBodyOpen = () => {
  const { isActive, setIsActive } = UseNav();
  const { darkMode } = UserMode();

  const variantsUl = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.5,
        delayChildren: 1, // Ajout d'un délai initial pour retarder le début de l'animation des enfants
        when: 'beforeChildren',
      },
    },
  };

  const childVariantsUl = {
    hidden: {
      opacity: 0,
      scale: 1,
    },
    visible: {
      opacity: 1,
      scale: 2,
    },
  };

  return (
    <>
      {isActive && (
        <nav className="flex flex-col items-center justify-between gap-8 p-8 my-auto h-full">
          <motion.ul
            variants={variantsUl}
            initial="hidden"
            animate="visible"
            className="my-auto grid gap-24"
          >
            {navItems.map((item, idx) => (
              <motion.li
                key={idx}
                variants={childVariantsUl}
                transition={{
                  duration: 0.65,
                  delay: idx * 0.2,
                }}
                className={clsx(
                  'text-4xl sm-md:text-3xl max-sm:text-2xl',
                  darkMode ? 'text-white' : 'text-black'
                )}
              >
                <Link to={item.to} onClick={() => setIsActive(!isActive)}>
                  {item.name}
                </Link>
              </motion.li>
            ))}
          </motion.ul>
          <motion.ul className="flex gap-4">
            <SocialLinks />
          </motion.ul>
        </nav>
      )}
    </>
  );
};

export default NavBodyOpen;
